export default "__VITE_PUBLIC_ASSET__a58bb303__"